<template>
  <div style="z-index: -1" class="absolute top-56 left-96">
    <img src="../../../assets/images/cirlce-lg.png" alt="circle-lg" />
  </div>
</template>

